
import { mapGetters } from 'vuex';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    name: 'HeaderTop',
    mixins: [HeaderNavigationMixin],
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getCurrentTheme: 'global/getCurrentTheme',
            fileData: 'getFileData',
        }),
    },
    watch: {
        '$i18n.locale': '$fetch',
    },
    methods: {
        async handleFileDownload() {
            try {
                if (this.fileData?.file) {
                    const link = document.createElement('a');
                    link.href = this.fileData.file;

                    const filename = this.fileData.file.split('/').pop();
                    link.setAttribute('download', filename);
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else if (this.fileData?.file_link) {
                    window.open(this.fileData.file_link, '_blank');
                } else {
                    console.error('No file or file link available.');
                }
            } catch (error) {
                console.error('Error handling file download or redirect:', error);
            }
        },
    },
    async fetch() {
        await this.$store.dispatch('fetchFileData');
    },
};
